export class IncrementalTitleGenerator {
  constructor(private readonly _existing: string[]) {}

  public generateWith(base: string): string {
    const generatedCounter = this._existingCounters().length
      ? Math.max(...this._existingCounters()) + 1
      : 1;
    return `${base} ${generatedCounter}`;
  }

  private _existingCounters(): number[] {
    const regex = / (\d+)/;
    return this._existing
      .filter((existing) => existing)
      .map((title) =>
        (title as unknown as string).match(regex)
          ? Number((title as unknown as string).match(regex)![1])
          : null
      )
      .filter((n): n is number => !!n);
  }
}
